import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import { loaderReducer } from "./loaderSlice";
import { baseUrlApi } from "./redux-services/baseUrlApi";

const rootReducer = combineReducers({
  [baseUrlApi.reducerPath]: baseUrlApi.reducer
});

const allMiddleware = [
  baseUrlApi.middleware
];

export const store = configureStore({
  reducer: { loader: loaderReducer, root: rootReducer },
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(...allMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;